import { render, staticRenderFns } from "./UploadVideo.vue?vue&type=template&id=f976f24e&"
import script from "./UploadVideo.vue?vue&type=script&lang=js&"
export * from "./UploadVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports